module.exports = __webpack_public_path__ + "img/logo_seculos.5b3988eb.png";